import React from 'react';

interface ProjectSelectionHeaderProps {
  selectedOrganizationName?: string;
  hasSelectedOrganization: boolean;
}

export const ProjectSelectionHeader: React.FC<ProjectSelectionHeaderProps> = ({
  selectedOrganizationName,
  hasSelectedOrganization,
}) => (
  <h3 className="text-lg font-semibold mb-2 text-gray-900">
    {hasSelectedOrganization
      ? `Select Projects from ${selectedOrganizationName}:`
      : 'Select Projects from All Subcontractors:'}
  </h3>
);